export const questions = [
  {
    id: 1,
    region: "Cerebrum",
    skill: "Perception",
    text: "How often do you notice small details in your environment (e.g., changes in decor, background noises)?",
    textOther: "How often do they notice small details in their environment (e.g., changes in decor, background noises)?",
    scoring: "Reverse",
    type: "Frequency"
  },
  {
    id: 2,
    region: "Cerebrum",
    skill: "Attention",
    text: "When working on something you love, how easily can you tune out distractions?",
    textOther: "When working on something they love, how easily can they tune out distractions?",
    scoring: "Reverse",
    type: "Frequency"
  },
  {
    id: 3,
    region: "Cerebrum",
    skill: "Attention",
    text: "How often do you realize you've been staring into space without meaning to?",
    textOther: "How often do they realize they've been staring into space without meaning to?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 4,
    region: "Cerebrum",
    skill: "Initiation",
    text: "How often do you put off starting tasks until the last minute?",
    textOther: "How often do they put off starting tasks until the last minute?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 5,
    region: "Cerebrum",
    skill: "Inhibition",
    text: "How often do you act on impulses you later regret (e.g., buying something unnecessary, saying something harsh)?",
    textOther: "How often do they act on impulses they later regret (e.g., buying something unnecessary, saying something harsh)?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 6,
    region: "Cerebrum",
    skill: "Self-Monitoring",
    text: "How often do others point out mistakes you didn't notice yourself?",
    textOther: "How often do others point out mistakes they didn't notice themselves?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 7,
    region: "Cerebrum",
    skill: "Self-Correcting",
    text: "When you catch an error, how likely are you to fix it immediately?",
    textOther: "When they catch an error, how likely are they to fix it immediately?",
    scoring: "Reverse",
    type: "Frequency"
  },
  {
    id: 8,
    region: "Cerebrum",
    skill: "Pacing",
    text: "How often do you finish tasks much faster or slower than expected?",
    textOther: "How often do they finish tasks much faster or slower than expected?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 9,
    region: "Limbic System",
    skill: "Emotional Regulation",
    text: "How often do small frustrations ruin your mood for hours?",
    textOther: "How often do small frustrations ruin their mood for hours?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 10,
    region: "Cerebrum",
    skill: "Planning",
    text: "When tackling a big project, how often do you feel unsure where to start?",
    textOther: "When tackling a big project, how often do they feel unsure where to start?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 11,
    region: "Cerebrum",
    skill: "Decision-Making",
    text: "How often do you feel paralyzed when choosing between options?",
    textOther: "How often do they feel paralyzed when choosing between options?",
    scoring: "Standard",
    type: "Frequency"
  },
  {
    id: 12,
    region: "Brainstem",
    skill: "Sensory Processing",
    text: "Do textures (like clothing tags or certain foods) bother you more than others?",
    textOther: "Do textures (like clothing tags or certain foods) bother them more than others?",
    scoring: "Standard",
    type: "YesNo"
  }
];

export const backgroundQuestions = [
  {
    id: 24,
    text: "Have you received any executive function-related diagnoses?",
    textOther: "Have they received any executive function-related diagnoses?",
    type: "background"
  },
  {
    id: 25,
    text: "Have you experienced trauma?",
    textOther: "Have they experienced trauma?",
    type: "background"
  }
];